import {
  GET_CIVILBUDGETSCHEDULE,
  GET_CIVILBUDGETSCHEDULE_SUCCESS,
  GET_CIVILBUDGETSCHEDULE_FAIL,
  DELETE_CIVILBUDGETSCHEDULE,
  DELETE_CIVILBUDGETSCHEDULE_SUCCESS,
  DELETE_CIVILBUDGETSCHEDULE_FAIL,
  UPDATE_CIVILBUDGETSCHEDULE,
  UPDATE_CIVILBUDGETSCHEDULE_SUCCESS,
  UPDATE_CIVILBUDGETSCHEDULE_FAIL,
  ADD_NEW_CIVILBUDGETSCHEDULE,
  ADD_CIVILBUDGETSCHEDULE_SUCCESS,
  ADD_CIVILBUDGETSCHEDULE_FAIL,
  CIVILBUDGETSCHEDULE_LOADING,
  CIVILBUDGETSCHEDULE_RESET
} from "./actionType";

export const resetCivilBudgetScheduleState = (actionType) => ({
  type: CIVILBUDGETSCHEDULE_RESET,
  payload: { actionType },
});

export const getCivilBudgetScheduleSuccess = (actionType, data) => ({
  type: GET_CIVILBUDGETSCHEDULE_SUCCESS,
  payload: { actionType, data },
});

export const getCivilBudgetScheduleFail = (actionType, error) => ({
  type: GET_CIVILBUDGETSCHEDULE_FAIL,
  payload: { actionType, error },
});

export const getCivilBudgetSchedule = data => ({
  type: GET_CIVILBUDGETSCHEDULE,
  payload: data,
});

export const getCivilBudgetScheduleLoading = () => ({
  type: CIVILBUDGETSCHEDULE_LOADING
});

export const deleteCivilBudgetSchedule = data => ({
  type: DELETE_CIVILBUDGETSCHEDULE,
  payload: data,
});

export const deleteCivilBudgetScheduleSuccess = data => ({
  type: DELETE_CIVILBUDGETSCHEDULE_SUCCESS,
  payload: data,
});

export const deleteCivilBudgetScheduleFail = error => ({
  type: DELETE_CIVILBUDGETSCHEDULE_FAIL,
  payload: error,
});

export const updateCivilBudgetSchedule = data => ({
  type: UPDATE_CIVILBUDGETSCHEDULE,
  payload: data,
});

export const updateCivilBudgetScheduleFail = error => ({
  type: UPDATE_CIVILBUDGETSCHEDULE_FAIL,
  payload: error,
});

export const updateCivilBudgetScheduleSuccess = data => ({
  type: UPDATE_CIVILBUDGETSCHEDULE_SUCCESS,
  payload: data,
});

export const addNewCivilBudgetSchedule = data => ({
  type: ADD_NEW_CIVILBUDGETSCHEDULE,
  payload: data,
});

export const addCivilBudgetScheduleSuccess = data => ({
  type: ADD_CIVILBUDGETSCHEDULE_SUCCESS,
  payload: data,
});

export const addCivilBudgetScheduleFail = error => ({
  type: ADD_CIVILBUDGETSCHEDULE_FAIL,
  payload: error,
});